<template>

    <app-layout :title="title">


        <todays-exercise-widget class="mb-4 sm:mb-8"
            :target="target">
        </todays-exercise-widget>


        <div class="flex flex-col w-full">


            <div class="flex flex-col w-full bg-white rounded-t-md sm:rounded-2xl shadow-sm">


                <div class="flex items-center justify-center rounded-t-md sm:rounded-t-2xl bg-gray-400">

                    <div class="w-full rounded-t-md sm:rounded-t-2xl overflow-hidden" style="padding:56.25% 0 0 0;position:relative;">

                        <iframe :src="`https://player.vimeo.com/video/${vimeo_id}/?title=0&byline=0&portrait=0&autoplay=1`"
                            style="position:absolute;top:0;left:0;width:100%;height:100%;"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen>
                        </iframe>

                    </div>

                </div>


                <div class="flex flex-col p-7 lg:p-14">


                    <div class="flex w-full items-start mb-2">

                        <div class="text-lg sm:text-4xl lg:text-font-42 font-black font-nexa mr-1 mb-2 sm:mb-4 lg:mr-6 leading-tight">

                            {{ name }}

                        </div>


                        <div class="flex items-center cursor-pointer h-[22px]"
                            :class="{
                                'remove_favorite_button' : active,
                                'add_favorite_button' : ! active
                            }"
                            @click.stop="handle_click_exercise_for_user_favorit({
                                slug
                            })">


                            <font-awesome-icon
                                id="active_icon"
                                :icon="['fas', 'heart']"
                                class="text-sm sm:text-2xl text-red mr-4"
                                :class="{
                                    'hidden': ! active
                                }">
                            </font-awesome-icon>

                            <font-awesome-icon
                                id="deactive_icon"
                                :icon="['far', 'heart']"
                                class="text-sm sm:text-2xl text-blue mr-4"
                                :class="{
                                    'hidden': active
                                }">
                            </font-awesome-icon>

                            <p v-if="active"
                               class="hidden lg:inline-block text-sm text-black text-opacity-40 select-none">

                                {{ __('Remove from favorites') }}

                            </p>

                            <p v-else
                                class="hidden lg:inline-block text-sm text-black text-opacity-40 select-none">

                                {{ __('Add to favorites') }}

                            </p>

                        </div>

                    </div>

                    <div class="flex flex-col sm:flex-row">
                        <div class="flex items-start mb-2 sm:mb-9">

                            <div class="font-bold text-xs sm:text-xl sm:leading-[1.5rem] lg:text-2xl lg:leading-normal mr-2">{{ __('Categories') }}:</div>

                            <div class="font-normal text-xs items-center sm:text-xl sm:leading-[1.5rem] lg:text-2xl lg:leading-normal mr-6">{{ exercise_categories_names }}</div>

                        </div>

                        <div class="flex flex-row">
                            <div class="font-bold text-xs sm:text-xl sm:leading-[1.5rem] lg:text-2xl lg:leading-normal mr-2">{{ __('Instructor') }}:</div>

                            <div class="font-normal text-xs sm:text-xl sm:leading-[1.5rem] lg:text-2xl lg:leading-normal mr-6"> {{ instructor._full_name }}</div>
                        </div>
                    </div>


                    <div class="text-xs sm:text-lg sm:leading-8 mt-2"
                         v-html="description">
                    </div>


                </div>


            </div>


        </div>

    </app-layout>

</template>

<script>
import {defineComponent} from "vue";
import AppLayout from "../Layouts/AppLayout";
import TodaysExerciseWidget from "@/Widgets/TodaysExerciseWidget";

export default defineComponent({

    name: "Exercise",

    components: {
        TodaysExerciseWidget,
        AppLayout
    },

    props: {
        id: Number,
        slug: String,
        name: String,
        description: String,
        thumbnail_url: String,
        active: {
            type: Boolean,
            default: false
        },
        instructor: {
            type: Object,
            default: () => {
                return {
                    id: 1,
                    first_name: 'Birgitte',
                    last_name: 'Nymann',
                    _full_name: 'Birgitte Nymann'
                }
            }
        },
        vimeo_id: {
            type: String,
            default: () => {
                return '646599504';
            }
        },
        categories: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        slug: 'shoulder',
                        name: 'Shoulder',
                        description: 'Shoulder Description',
                        icon_url: '/storage/shoulder-icon.png'
                    },
                    {
                        id: 2,
                        slug: 'neck',
                        name: 'Neck',
                        description: 'Neck Description',
                        icon_url: '/storage/neck-icon.png'
                    }
                ]
            }
        },
        target: {
            type: Object
        }
    },


    computed: {

        title() {

            return this.__(this.name);

        },


        exercise_categories_names() {

            let
                text = '',
                exercise_category,
                counter = 0
            ;

            for (exercise_category of this.categories) {

                if ( counter === 0 ) {

                    text += exercise_category.name;

                }
                else {

                    text += ', ' + exercise_category.name;

                }

                counter++;

            }


            return text;

        }

    },


    methods: {

        handle_click_exercise_for_user_favorit(exercise) {              let debug_id = Debug.init_method('handle_click_exercise_for_user_favorit',false);

            let
                route = this.route('exercise_user_favorite_toggle', {
                    exercise: exercise.slug
                })
            ;                                                           Debug.log(debug_id,249,{route});


            this.$inertia
                .patch( route, {
                    preserveScroll: true,
                    onSuccess: this.reload_page,
                });

        },


        reload_page() {

            this.$inertia.reload({
                only: ['active']
            });

        }

    }

});
</script>

<style scoped>

.remove_favorite_button:hover #active_icon {
    display: none;
}

.remove_favorite_button:hover #deactive_icon {
    display: block;
}

.add_favorite_button:hover #active_icon {
    display: block;
}

.add_favorite_button:hover #deactive_icon {
    display: none;
}

</style>
